import { render, staticRenderFns } from "./PopupHeader.vue?vue&type=template&id=1543b10e&scoped=true&"
import script from "./PopupHeader.vue?vue&type=script&lang=js&"
export * from "./PopupHeader.vue?vue&type=script&lang=js&"
import style0 from "./PopupHeader.vue?vue&type=style&index=0&id=1543b10e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1543b10e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VSheet,VToolbar,VToolbarTitle})
